<div class="flex flex-col gap-4">
  @if (isPlatformView()) {
    <knk-platform-view-summary
      [label]="sectionMetadata().label ?? ''"
      [path]="resolvedSection()?.Path ?? ''"
      [entityName]="entity()?.displayName || sectionMetadata().entityName || ''"
    />
  } @else {
    <div class="flex flex-col gap-4 p-4 bg-white rounded-lg shadow">
      <span class="font-semibold text-base">{{ 'dynamicEditor.mainSettings' | translate }}</span>
      <div class="flex gap-2 items-end">
        <knk-entity-selector
          [(entity)]="entity"
          [confirmChange]="confirmEntityChange"
          [disabled]="hasConfigCode()"
        ></knk-entity-selector>

        @if (entity(); as entity) {
          <knk-page-label-input [(label)]="label"></knk-page-label-input>
          <knk-page-path-input [(path)]="path"></knk-page-path-input>
        }
      </div>

      @if (hasConfigCode()) {
        <div class="flex items-center gap-2" data-testid="section-config-code-hint">
          <span class="text-xs text-gray-500">{{ 'dynamicEditor.configByCode' | translate }}</span>
          @if (!isPlatformView()) {
            <button
              tuiButton
              type="button"
              size="xs"
              appearance="flat"
              data-testid="section-config-code-remove"
              (click)="removeConfigCode()"
            >
              {{ 'dynamicEditor.removeConfigCode' | translate }}
            </button>
          }
        </div>
      }

      @if (entity()) {
        <div class="flex gap-4 items-end flex-wrap">
          <knk-card-selector
            class="w-[300px]"
            [(cardPath)]="linkedCardPath"
            [disabled]="hasConfigCode()"
          ></knk-card-selector>

          <label tuiLabel>
            {{ 'dynamicEditor.tableSize' | translate }}
            <tui-textfield class="w-[300px]" tuiChevron tuiTextfieldSize="m" [tuiTextfieldCleaner]="false">
              <input
                tuiSelect
                [ngModel]="tableSizeLabel()"
                [disabled]="hasConfigCode()"
                (ngModelChange)="updateTableSizeFromLabel($event)"
              />
              <tui-data-list-wrapper *tuiTextfieldDropdown new [items]="tableSizeLabels" />
            </tui-textfield>
          </label>

          @if (linkedCardPath()) {
            <label tuiLabel>
              <input
                type="checkbox"
                tuiCheckbox
                [(ngModel)]="allowCreate"
                [disabled]="hasTopBarCode() || hasConfigCode()"
              />
              {{ 'dynamicEditor.allowCreate' | translate }}
            </label>
            @if (hasTopBarCode() && !hasConfigCode()) {
              <span class="text-xs text-gray-500" data-testid="section-allow-create-code-hint">
                {{ 'dynamicEditor.createButtonByCode' | translate }}
              </span>
            }
          }

          <label tuiLabel>
            <input
              type="checkbox"
              tuiCheckbox
              [(ngModel)]="allowDelete"
              [disabled]="hasConfigCode()"
              data-testid="section-editor-allow-delete"
            />
            {{ 'dynamicEditor.allowDelete' | translate }}
          </label>

          <label tuiLabel>
            <input
              type="checkbox"
              tuiCheckbox
              [(ngModel)]="showManualFilter"
              [disabled]="hasConfigCode()"
              data-testid="section-editor-manual-filter"
            />
            {{ 'dynamicEditor.manualFilter' | translate }}
          </label>

          <label tuiLabel>
            <input
              type="checkbox"
              tuiCheckbox
              [(ngModel)]="showFilterPresets"
              [disabled]="hasConfigCode()"
              data-testid="section-editor-filter-presets"
            />
            {{ 'dynamicEditor.filterPresets' | translate }}
          </label>

          @if (showFilterPresets()) {
            <label tuiLabel>
              <input
                type="checkbox"
                tuiCheckbox
                [(ngModel)]="importLegacyFolders"
                [disabled]="hasConfigCode()"
                data-testid="section-editor-legacy-folders"
              />
              {{ 'dynamicEditor.legacyFilters' | translate }}
            </label>
          }

          <button
            tuiButton
            appearance="outline"
            size="m"
            type="button"
            [disabled]="hasTopBarCode() || hasConfigCode()"
            (click)="openTopActions()"
          >
            {{ 'dynamicEditor.topBarActions' | translate }}
            @if (topActions().length > 0 && !hasTopBarCode() && !hasConfigCode()) {
              <span class="ml-1 text-xs bg-blue-100 text-blue-600 rounded px-1">{{ topActions().length }}</span>
            }
          </button>
          @if (hasTopBarCode() && !hasConfigCode()) {
            <div class="flex items-center gap-2" data-testid="section-top-bar-code-hint">
              <span class="text-xs text-gray-500">{{ 'dynamicEditor.topBarByCode' | translate }}</span>
              <button
                tuiButton
                type="button"
                size="xs"
                appearance="flat"
                data-testid="section-top-bar-code-remove"
                (click)="removeTopBarCode()"
              >
                {{ 'dynamicEditor.removeTopBarCode' | translate }}
              </button>
            </div>
          }
        </div>
      }
    </div>

    @if (entity(); as entity) {
      @if (!hasConfigCode()) {
        <knk-column-configurator [entityName]="entity.name" [(config)]="columns"></knk-column-configurator>
      }
    }
  }
</div>

<ng-template #actionTemplate>
  <div class="flex items-center gap-2">
    @if (hasUnsavedChanges()) {
      <span class="text-orange-500 text-sm" data-testid="unsaved-changes-banner">{{
        'dynamicEditor.unsavedChanges' | translate
      }}</span>
    }
    @if (resolvedSection()) {
      <button tuiButton appearance="secondary" size="m" type="button" (click)="saveAsCopy()">
        {{ 'dynamicEditor.saveAsCopy' | translate }}
      </button>
    }
    @if (!isPlatformView()) {
      <button tuiButton type="button" size="m" [loading]="isSaving()" (click)="saveChanges()">
        {{ 'dynamicEditor.saveChanges' | translate }}
      </button>
    }
  </div>
</ng-template>
